var $ = global.jQuery = global.$;

var shareTmpl = require('../templates/shareLinks.dot');

var _Base = require('./_Base');

/**
 * Share widget
 * @class
 * @extends _Base
 */
var Share = _Base.extend(
  /** @lends Share.prototype */
  {
    /**
     * Initialisation method
     * @private
     */
    init: function() {
      var self = this;

      this.shareUrl = this.$el.data('shareUrl') || window.location.href;

      this.overlay = $('#shareOverlay').children().eq(0).clone();

      this.overlay.find('[data-links]').html(shareTmpl({
        shareUrl: this.shareUrl
      }));

      this.overlay.find('[data-overlay-close]').on('click', function(event) {
        event.preventDefault();
        self.close();
      });

      this.$el.on('click', function(event) {
        event.preventDefault();
        self.open();
      });

    },
    open: function() {
      $('body').append(this.overlay);
      this.overlay.velocity('fadeIn');
    },
    close: function() {
      var self = this;
      this.overlay.velocity('fadeOut', {
        complete: function() {
          self.overlay.detach();
        }
      });
    }
  });

module.exports = Share;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/Share.js
 ** module id = 43
 ** module chunks = 0 1
 **/